// external imports
import React, { useEffect, useState, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Col } from 'reactstrap';
import { Tooltip } from 'react-tooltip';
import Skeleton from 'react-loading-skeleton';

// local imports
//import exportConfig from '../config';

// custom hooks & context
import { endpointContext } from '../contexts/endpointContext';
import { pipelineContext } from '../contexts/pipelineContext';
import useGainsQCApi from '../services/useGainsQCApi';
import SendCapsBackModal from '../components/dashboard/SendCapsBackModal';
import Breadcrumb from '../components/nav/Breadcrumb';
import CapturesTable from '../components/tables/CapturesTable';
import { stockpileFields } from '../components/tables/tableFields';

const UsersCaptures = (props) => {
	const endpointContextUserCaps = useContext(endpointContext);
	const pipelineContextUserCaps = useContext(pipelineContext);

	const [qcType, setQCType] = useState('smelters');
	const [qcCaps, setQCCaps] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [selectedCaps, setSelectedCaps] = useState([]);

	const navigate = useNavigate();

	const userCapsSmelters = useGainsQCApi();
	const userCapsStockpiles = useGainsQCApi();
	const sendingCapsBack = useGainsQCApi();
	const fetchFullCapturesData = useGainsQCApi();

	useEffect(() => {
		document.title = 'GAINS QC | Your captures';
		setLoading(true);
		fetchCapturesInfo();
	}, []);

	useEffect(() => {
		if (sendingCapsBack.data && !sendingCapsBack.error) {
			if (sendingCapsBack.data.hasOwnProperty('message')) {
				setSelectedCaps([])
				fetchCapturesInfo();
			}
		}
	}, [sendingCapsBack.data, sendingCapsBack.error]);

	const fetchCapturesInfo = async () => {
		let userHandle = `${props.authProps.userAttributes.givenName.toLowerCase()}.${props.authProps.userAttributes.familyName.toLowerCase()}`;

		if (qcType === 'smelters') {
			await userCapsSmelters.makeRequest(
				`/smelters/user_queue?commodity_id=3&qcUser=${userHandle}`,
				'GET',
				null,
				pipelineContextUserCaps.notificationsEnabled
					? `your smelter captures`
					: null,
				undefined,
				undefined
			);
		} else {
			await userCapsStockpiles.makeRequest(
				`/smelters/user_queue?commodity_id=4&qcUser=${userHandle}`,
				'GET',
				null,
				pipelineContextUserCaps.notificationsEnabled
					? `your stockpiles captures`
					: null,
				undefined,
				undefined
			);
		}
	};

	useEffect(() => {
		if (
			userCapsSmelters.data &&
			!userCapsSmelters.error &&
			userCapsSmelters.data.hasOwnProperty('data') &&
			!endpointContextUserCaps.loading
		) {
			console.log(userCapsSmelters.data.data);

			const uniqueQueueIds = [
				...new Set(userCapsSmelters.data.data.map((item) => item.queue_id))
			];

			let newCapsObj = {};
			for (let id in uniqueQueueIds) {
				newCapsObj[uniqueQueueIds[id]] = userCapsSmelters.data.data.filter(
					(cap) => cap.queue_id === uniqueQueueIds[id]
				);
			}

			console.log(newCapsObj);

			setQCCaps(userCapsSmelters.data.data);
			//setQCCaps(newCapsObj);
			setLoading(false);
		} else {
			setError(true);
		}
	}, [
		userCapsSmelters.data,
		userCapsStockpiles.data,
		endpointContextUserCaps.loading
	]);



	const getCaptures = async () => {
		if (selectedCaps.length > 0) {
			const uniqueComms = [...new Set(selectedCaps.map((item) => item.commodity_id))];
			let captureIdObj = {};

			for (let comm in uniqueComms) {
				captureIdObj[uniqueComms[comm]] = selectedCaps
					.filter((cap) => cap.commodity_id === uniqueComms[comm])
					.slice(0, 100)
					.map((cap) => cap.capture_id);
			}


			await fetchFullCapturesData.makeRequest(
				`/${qcType}/captures?captureIds=${JSON.stringify(captureIdObj)}`,
				'GET',
				null,
				'fetching captures'
			);
		}
	};

	useEffect(() => {
		if (fetchFullCapturesData.data?.data && !fetchFullCapturesData.error) {

			let sortedList = fetchFullCapturesData.data.data.sort((a, b) => {
				// order by site_id
				if (a.site_id < b.site_id) return -1;
				if (a.site_id > b.site_id) return 1;

				// then by capture date
				return new Date(a.captured) - new Date(b.captured);
			});


			pipelineContextUserCaps.setStraightToQC(true);
			pipelineContextUserCaps.setCapsInPipeline(sortedList);
			pipelineContextUserCaps.setComm(qcType);
			pipelineContextUserCaps.setQCType('straightToQCFromUserCaps')
			pipelineContextUserCaps.setQCInProgress(true);
			navigate('/qc');
		}
	}, [fetchFullCapturesData.data, fetchFullCapturesData.error]);

	const moveToQC = (capsQCUser) => {
		//checkAllCapsAreAssignedToUser(capsQCUser)

		pipelineContextUserCaps.setStraightToQC(true);
		pipelineContextUserCaps.setCapsInPipeline(capsQCUser);
		pipelineContextUserCaps.setComm(qcType);
		pipelineContextUserCaps.setQCInProgress(true);

		// pipelineContextUserCaps.setProgressBar({
		// 	width: 4 * (100 / 7),
		// 	title: 'View Captures'
		// });

		navigate('/qc');
	};

	const userCapturesProps = [
		{
			title: 'Home',
			currentPage: false,
			link: '/',
			afterCurrent: false,
			warning: false
		},
		{
			title: 'User captures',
			currentPage: true,
			link: '/user_capture',
			afterCurrent: false,
			warning: false
		}
	];

	console.log(selectedCaps);

	return (
		<>
			{props.authProps.isAuthenticated ? (
				<>
					<SendCapsBackModal
						user={props.authProps.userAttributes}
						capturesCurrentlyInQC={selectedCaps}
						qcCat={qcType}
						setQCCat={setQCType}
						sendingCapsBack={sendingCapsBack}
						loading={loading}
						setLoading={setLoading}
					/>
					<Col className="px-0">
						<div className="contentContainer" style={{ height: 'auto' }}>
							<Breadcrumb props={userCapturesProps} marginTop={18} />
							<hr></hr>

							<div className="row">
								<div className="col pb-3">
									<div class="form-check-dashboard-qcinfo pt-1">
										<input
											className="form-check-input-dashboard-qcinfo"
											type="radio"
											name="flexRadioDefault"
											id="flexRadioDefault1"
											checked={qcType === 'smelters'}
											//onClick={(e) => setQCType('smelters')}
										></input>
										<label
											class="form-check-label-dashboard-qcinfo"
											for="flexRadioDefault1"
											data-tooltip-id="dashboard-qcinfo-smelters"
										>
											<i className="fa-solid fa-city"></i>
										</label>
									</div>
									<div className="form-check-dashboard-qcinfo">
										<input
											className="form-check-input-dashboard-qcinfo"
											type="radio"
											name="flexRadioDefault"
											checked={qcType === 'stockpiles'}
											id="flexRadioDefault2"
											//onClick={(e) => setQCType('stockpiles')}
										></input>
										<label
											className="form-check-label-dashboard-qcinfo"
											for="flexRadioDefault2"
											data-tooltip-id="dashboard-qcinfo-stockpiles"
										>
											<i class="fa-solid fa-cubes-stacked"></i>
										</label>
									</div>
								</div>

								<h3>
									Your <strong>{qcType}</strong> captures
								</h3>
							</div>

							<h6>
								Use this page to view captures which are assigned to you in the
								database
							</h6>

							<div className="row mt-4 mx-2">
								{endpointContextUserCaps.loading ? (
									<h4 style={{ display: 'flex', alignItems: 'center' }}>
										<strong style={{ display: 'inline', alignItems: 'center' }}>
											<Skeleton width={30} />
										</strong>
										<span
											style={{
												display: 'inline',
												alignItems: 'center',
												paddingLeft: '6px'
											}}
										>
											captures in {qcType} QC
										</span>
									</h4>
								) : (
									<h4>
										<strong>{qcCaps.length}</strong> captures in {qcType} QC
									</h4>
								)}

								<div>
									{qcCaps.length !== 0 && (
										<p>
											These captures are assigned to you and nobody else can
											access them to QC. Please either continue with QC or
											release them from your pipeline.
										</p>
									)}
								</div>

								{loading ? (
									<div style={{ height: '25vh' }}>
										<table className="captureTable">
											<thead className="thead-dark">
												<tr>
													<th>Capture ID</th>
													<th>Commodity</th>
													<th>QC User</th>
													<th>Exp Time</th>
												</tr>
											</thead>
											<tbody className="table-group-divider">
												{Array.from({ length: 4 }, (_, rowIndex) => (
													<tr key={rowIndex}>
														{Array.from({ length: 4 }, (_, rowIndex) => (
															<td>
																<Skeleton />
															</td>
														))}
													</tr>
												))}
											</tbody>
										</table>

										{/* <Skeleton width={'100%'} height={'100%'} /> */}
									</div>
								) : (
									<>
										{qcType === 'smelters' && (
											<>
												{qcCaps.length > 0 ? (
													<div
														style={{ maxHeight: '500px', overflowY: 'scroll' }}
													>
														<table className="captureTable">
															<thead className="thead-dark">
																<tr>
																	<th>Capture ID</th>
																	<th>Commodity</th>
																	<th>QC User</th>
																	<th>Queue ID</th>
																	<th>Exp Time</th>
																	<th>
																		Select all{' '}
																		<input
																			className="form-check-input"
																			type="checkbox"
																			checked={
																				selectedCaps.length === qcCaps.length
																			}
																			onChange={
																				selectedCaps.length === qcCaps.length
																					? () => setSelectedCaps([])
																					: () =>
																							setSelectedCaps(
																								qcCaps
																							)
																			}
																		></input>

																	</th>
																</tr>
															</thead>

															<tbody>
																{qcCaps.map((cap) => (
																	<tr>
																		<td>{cap.capture_id}</td>
																		<td>
																			{
																				endpointContextUserCaps.dbData.allCommodities.filter(
																					(comm) => comm.id === cap.commodity_id
																				)[0].siteTypeStr
																			}
																		</td>
																		<td>{cap.user_id}</td>
																		<td>{cap.queue_id}</td>
																		<td>{cap.expiration_time}</td>
																		<td>
																			<input
																				className="form-check-input"
																				onChange={() => {
																					setSelectedCaps((prev) => {
																					  const exists = prev.some((c) => c.capture_id === cap.capture_id);
																					  return exists
																						? prev.filter((c) => c.capture_id !== cap.capture_id)
																						: [...prev, cap];
																					});
																				  }}
																				  checked={selectedCaps.some((c) => c.capture_id === cap.capture_id)}
																				type="checkbox"
																			></input>
																		</td>
																	</tr>
																))}
															</tbody>
														</table>
													</div>
												) : (
													<table
														className="captureTable"
														style={{ maxHeight: '500px', overflowY: 'scroll' }}
													>
														<thead className="thead-dark">
															<tr>
																<th>Capture ID</th>
																<th>Commodity</th>
																<th>QC User</th>
																<th>Exp Time</th>
															</tr>
														</thead>

														<tbody>
															<tr>
																<td>-</td>
																<td>-</td>
																<td>-</td>
																<td>-</td>
															</tr>
														</tbody>
													</table>
												)}
											</>
										)}

										{qcType === 'stockpiles' && (
											<CapturesTable
												fields={stockpileFields}
												captures={qcCaps}
												qcCat={qcType}
												tableHeight={'400px'}
											/>
										)}

										{qcCaps.length !== 0 && (
											<div className="d-flex justify-content-end py-4">
												<button
													data-tooltip-id="dashboard-qc-caps"
													className="btn interactButton mx-2"
													style={{ width: '160px', height: '40px' }}
													disabled={selectedCaps.length === 0}
													//onClick={(e) => moveToQC(qcCaps)}
													onClick={(e) => getCaptures()}
												>
													QC {selectedCaps.length} captures
												</button>
												<button
													data-tooltip-id="dashboard-remove-caps"
													className="btn interactButtonSecondary mx-2"
													style={{ width: '200px', height: '40px' }}
													disabled={selectedCaps.length === 0}
													data-bs-toggle="modal"
													data-bs-target="#sendCapsBackModal"
												>
													Remove {selectedCaps.length} captures
												</button>
											</div>
										)}
									</>
								)}
							</div>
						</div>

						<Tooltip id="back-to-homepage">back to homepage</Tooltip>
						<Tooltip id="dashboard-qc-caps">
							Go straight to QC with these captures
						</Tooltip>
					</Col>

					<Tooltip id="dashboard-qcinfo-stockpiles">stockpiles</Tooltip>
					<Tooltip id="dashboard-qcinfo-smelters">smelters</Tooltip>
				</>
			) : (
				<Navigate to="/login" />
			)}
		</>
	);
};

export default UsersCaptures;
